<div class="landing-video">
  <video width="100%" height="auto" loop autoplay playsinline [muted]="true">
    <source src="/assets/images/landing-video/vid.mp4" type="video/mp4">
    Your browser does not support the video tag.
  </video>
</div>
